module.exports = __webpack_public_path__ + "img/Logo-Maipu-Salud.879889ff.png";